<div class="display-options" *ngIf="totalItems > 0">
  <div class="display-options__count">
    Showing {{ startItem }} - {{ endItem }} of {{ totalItems }}
    <select class="form-select" [value]="pageSize" (change)="onPageSizeChange($event)">
      <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
    </select>
  </div>
  <div class="display-options__filter"></div>
  <div class="display-options__pagination">
    <ul class="pagination" role="navigation" aria-label="Pagination">
      <li class="pagination__previous" [class.disabled]="currentPage <= 1">
        <a *ngIf="currentPage > 1" aria-label="Previous page" (click)="changePage(currentPage - 1)">Previous<span class="show-for-sr"> page</span></a>
        <span *ngIf="currentPage <= 1">Previous</span>
      </li>
      <li class="pagination__current">
        <span class="show-for-sr">You are on page </span>
        {{ currentPage }}
      </li>
      <li><a aria-label="Page {{ totalPages }}" (click)="changePage(totalPages)">{{ totalPages }}</a></li>
      <li class="pagination__next" [class.disabled]="currentPage >= totalPages">
        <a *ngIf="currentPage < totalPages" aria-label="Next page" (click)="changePage(currentPage + 1)">Next<span class="show-for-sr"> page</span></a>
        <span *ngIf="currentPage >= totalPages">Next</span>
      </li>
    </ul>
  </div>
</div>